export const NAVBAR_HEIGHT = 64;
export const SIDEBAR_WIDTH = 250;

export const VIDEO_CONTROLBAR_HEIGHT = 30;
